var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 191 271.9",
    style: {
      enableBackground: "new 0 0 191 271.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#04E6D4;stroke-width:1.767;stroke-miterlimit:10;stroke-dasharray:1.867,2.801;}\n\t.st1{fill:none;stroke:#04E6D4;stroke-width:1.767;stroke-miterlimit:10;stroke-dasharray:15.84,5.544;}\n\t.st2{fill:none;stroke:#04E6D4;stroke-width:1.767;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.9,19.4c0,0,69.5,115.7,115.5,236.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.3,35.5c0,0,69.5,115.7,115.5,236.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.1,237.3C144.1,116.9,74.6,1.2,74.6,1.2L0.4,40.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign2);
export default __webpack_public_path__ + "static/media/sign2.ca828622aa04f31ff5cef91d578d66e9.svg";
export { ForwardRef as ReactComponent };